/* eslint-disable spaced-comment,func-names,object-shorthand */
import React from 'react';
import request from 'superagent';
import Highstock from 'highcharts/highstock';
import Chart from "../Chart";
import API from "../../../config/API";
import {getDataFilesCacheVersion} from "../../../helpers/cache";

require('highcharts-more')(Highstock);
require('highcharts/modules/exporting')(Highstock);
require('highcharts/modules/export-data.src')(Highstock);
const ReactHighcharts = require('react-highcharts/ReactHighstock').withHighcharts(Highstock);

class CPPBidAskSpread extends Chart {

    componentDidMount() {
        request.get(API.getHost('data').concat(getDataFilesCacheVersion('/data-feeds/charts/BASI/BASI_graph1.csv'))).then(data => {

            const legendClickedMap = new Map();
                
            //names of labels in order of series. make sure they are the same as series header in data file
            const names = ['USD_IG*','USD_HY','EUR_IG','EUR_HY','GBP_IG','USD_EM'];

            let clicked = names.length;

            for(let i = 0; i < names.length; i+=1) {
                legendClickedMap.set(i, false);
            }

            const options = {
                //chart options
                chart: {
                    //set type of graph, where it renders
                    type: 'line',
                    renderTo: 'basi_overall_container',
                    height: 600,
                    style: {
                        fontFamily: 'Exo'
                    }
                },
                //set title of graph
                title: {
                    text: 'CP+ Corporate and Emerging Market BASI',
                    style: {
                        color: '#4D759E'
                    },
                    align: 'center'
                },
                //set xAxis title
                xAxis: {
                    title: {
                        text: 'Week',
                        style: {
                            color: '#4D759E',
                            fontWeight: 'bold'
                        }
                    }
                },
                //set yAxis info
                yAxis: [{
                    title: {
                        text: 'Percentage of par',
                        style: {
                            color: '#4D759E',
                            fontWeight: 'bold'
                        }
                    },
                    //set y-axis to the left side
                    opposite: false,
                    //set background grid line width
                    gridLineWidth: 1
                }],
                plotOptions: {
                    series: {
                      events: {
                        legendItemClick: function() {  
                            if(legendClickedMap.get(this.index)) {
                                clicked+=1;                             
                                legendClickedMap.set(this.index, false);
                                if(clicked === names.length) {
                                    for(let i=0; i<names.length; i+=1) {
                                        this.chart.series[i].show();
                                    }
                                } else {
                                    this.chart.series[this.index].hide();
                                }
                            }
                            else {
                                legendClickedMap.set(this.index, true);
                                if(clicked === names.length) {
                                    for (let i = 0; i < names.length; i+=1) {
                                        if(this.index !== i) {
                                            this.chart.series[i].hide();
                                        }
                                    }
                                } else {
                                    this.chart.series[this.index].show();
                                }
                                clicked-=1;
                            }
                            return false;
                        }
                      }
                    }
                },
                //stylize the tooltip
                tooltip: {
                    style: {
                        fontSize: '8'
                    },
                    borderWidth: 0,
                    pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
                    valueDecimals: 4
                },
                //enable and stylize the legend
                legend: {
                    enabled: true,
                    layout: 'horizontal',
                    align: 'center',
                    borderWidth: 1,
                    borderRadius: 5,
                    itemDistance: 20,
                    reversed: false
                },
                //set the starting range. 0-5. 5="All", 4="1yr", etc
                rangeSelector: {
                    selected: 4,
                    allButtonsEnabled: true
                },
                //set general plot options
                // plotOptions: {},
                //disable credits
                credits: {
                    enabled: false
                },
                //make download as csv format correctly
                navigator: {
                    series: {
                        includeInCSVExport: false
                    }
                },
                //set name of chart downloads
                exporting: {
                    buttons: {
                        contextButton: {
                          menuItems: [
                            "printChart",
                            "separator",
                            "downloadPNG",
                            "downloadJPEG",
                            "downloadPDF",
                            "downloadSVG",
                            "separator",
                            "downloadCSV",
                            "downloadXLS"
                            ]
                        }
                    }, 
                    filename: 'MarketAxess_basi_overall',
                    //enable download icon
                    enabled: true,
                    //add image to download
                    chartOptions: {
                        chart: {
                            events: {
                                load: function() {
                                    this.renderer.image('/public/images/charts/marketaxess_logo2.gif', 90, 75, 300, 48).attr({
                                        opacity: 0.1
                                    }).add();
                                }
                            }
                        },
                        //remove scrollbar and navigator from downloaded image
                        scrollbar: {
                            enabled: false
                        },
                        navigator:{
                            enabled: false
                        }
                    },
                    //make download as csv format correctly
                    csv: {
                        dateFormat: '%Y-%m-%d'
                    }
                },
                //set graph colors
                colors: [
                    '#1D5B7F',
                    '#76b34d',
                    '#636569',
                    '#6786B8',
                    '#8244FF',
                    '#848486',
                    '#a42a47',
                    '#f8dc32',
                    '#2a84b9',
                    '#91c271',
                    '#818388',
                    '#8598c6',
                    '#cd3d60',
                    '#f6e35b',
                    '#11374c',
                    '#476c2e',
                    '#3b3d3f',
                    '#374f75',
                    '#621903',
                    '#ad9506'
                ],
                //series to be filled by data
                series: []
            };

            //get csv file, multiply by 100 (divide by .01) and populate chart
            this.readCSV(options, data.text, 1.0, names);
            //for (let i = 0; i < options.series.length; i+=1) options.series[i].yAxis = i;
            this.setState({options});
        });
    }

    render() {
        if (!this.state.options) return null;
        return(
            <div className="container">
                <ReactHighcharts config={this.state.options}/>

                <p style={{fontSize: '15px'}}>*USD IG excludes MME Bonds (&lt;14 months to maturity).</p>

                <p style={{fontSize: '15px'}}>CP+ Corporate BASI is calculated as the weekly median of the daily CP+ EOD bid ask spread divided by par value. </p>
            </div>
        );
    }
}

export default CPPBidAskSpread;



// WEBPACK FOOTER //
// ./frontend/components/Charts/BASI/CPPBidAskSpread.jsx